import { render, staticRenderFns } from "./Microsoft.vue?vue&type=template&id=58ca1617&scoped=true&"
import script from "./Microsoft.vue?vue&type=script&lang=js&"
export * from "./Microsoft.vue?vue&type=script&lang=js&"
import style0 from "./Microsoft.vue?vue&type=style&index=0&id=58ca1617&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca1617",
  null
  
)

export default component.exports